/**
 * ⚠ These are used just to render the Sidebar!
 * You can include any link here, local or external.
 *
 * If you're looking to actual Router routes, go to
 * `routes/index.js`
 */
const routes = [
  {
    path: '/', // the url
    icon: 'Home', // the component being exported from icons/index.js
    name: 'Dashboard', // name that appear in Sidebar
  },
  {
    path: '/alerts', 
    icon: 'Bell', 
    name: 'Alerts', 
  },
  {
    path: '/cameras', 
    icon: 'Video', 
    name: 'Cameras', 
  },
  {
    path: '/rules', 
    icon: 'Desktop', 
    name: 'Rules', 
  },
  {
    path: '/sites', 
    icon: 'SitePin', 
    name: 'Sites', 
  },
  {
    path: '/zones', 
    icon: 'MapPin', 
    name: 'Zones', 
  },
  {
    path: '/counts',
    icon: 'Counts',
    name: 'Counts',
  },
  {
    path: '/safety-tasks',
    icon: 'Tasks',
    name: 'Safety Tasks',
  },
  // {
  //   path: '/aiassistant', 
  //   icon: 'Assistant', 
  //   name: 'AI Assistant', 
  // },
  {
    path: '/users', 
    icon: 'User', 
    name: 'Users', 
  },
  {
    path: '/settings', 
    icon: 'Setting', 
    name: 'Settings', 
  },
  
  
]

export default routes
